import configDev1 from './config/config.dev1.json';
import configQa1 from './config/config.qa1.json';
import configQa2 from  './config/config.qa2.json';
import configSandbox1 from './config/config.sandbox1.json';

const APP_NAME = 'imo-portal';

export function resolveConfig() {
    const hostname = window.location.hostname;
    if(hostname === "localhost") {
        return configSandbox1;
    } else if (hostname.startsWith(`${APP_NAME}.sandbox1`)) {
        return configSandbox1;
    } else if (hostname.startsWith(`${APP_NAME}.dev1`)) {
        return configDev1;
    } else if (hostname.startsWith(`${APP_NAME}.qa1`)) {
        return configQa1;
    } else if (hostname.startsWith(`${APP_NAME}-qa2`)) {
        return configQa2;
    }
    return configSandbox1;
}
